// @ts-ignore
import React from 'react';
import { Avatar } from 'antd';

type AntAvatarProps = {
  firstname?: string;
  lastname?: string;
  imageSrc?: string;
  backgroundColor?: string;
  height?: string;
  width?: string;
  fontSize?: string;
  color?: string;
};


const AntAvatar = ({ firstname, lastname, imageSrc, backgroundColor = "#171820", height, width, fontSize, color }: AntAvatarProps) => {
  return (
    <Avatar
      style={{
        backgroundColor: backgroundColor,
        textAlign: 'center',
        height: height || "70px",
        width: width || "70px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: fontSize || "24px",
        color: color || "#D9D9D9" 
      }}
    >
      <span style={{ fontSize: fontSize, color: color }}>
        {`${firstname?.charAt(0).toUpperCase() ?? ""}${lastname?.charAt(0).toUpperCase() ?? ""}`}
      </span>
      {imageSrc && <img src={imageSrc} alt={`${firstname} ${lastname}`} />}
    </Avatar>
  )
}

export default AntAvatar